import React, { Component } from 'react';
import MissionBillboard from './MissionBillboard'
import {baseUrl} from '../url'
import { Panel,Drawer, Form, FormGroup, FormControl, Button, ControlLabel, ButtonGroup, Uploader, Table } from 'rsuite';
import Axios from 'axios';
const { Column, HeaderCell, Cell } = Table;
const URL =baseUrl;
class CtrlPanel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            value: [],
            fromvalue: [],
            hometable: this.props.homeworkTable,
            id: this.props.userid,
            mission:[]
        }
    
    }
    close = () => {
        this.setState({
            show: false
        })
        //return this.props.show;
    }
    changeValue = (e) => {
        this.setState({
            fromvalue: e
        })
    }
    handleChange = (Value) => {
        //console.log(Value);
        if(Value===""){
            Value="作业"
        }
        this.setState({
            value:Value
        })
    }
    handleUpload = () =>{
        this.uploader.start();
    }
    uploadFrom = (url) => {
        return (
            <Panel header="上传作业" bordered>
                <Form fluid encType="multipart/form-data" action={url} method="post" name="upload">
                <FormGroup>
                    <ControlLabel>作业标题</ControlLabel>
                        <FormControl name="title" onChange={this.changeValue} placeholder="请输入标题(必须)"/>
                        <Uploader
                            name="files"
                            action={url + "?title=" + this.state.fromvalue +"&uploadername="+this.props.user}
                            draggable
                            autoUpload={false}
                            withCredentials={true}
                            onChange={this.handleChange}
                            ref={ref => {
                                this.uploader = ref;
                            }}
                            onSuccess={res => { alert("上传成功！");this.props.myupload(this.state.id) }}
                            
                        >
                        <div >点击或拖拽文件到此区域上传</div>
                    </Uploader>
                </FormGroup>
                <FormGroup>
                        <Button appearance="primary" disabled={!this.state.value.length} onClick={this.handleUpload}>开始上传</Button>
                </FormGroup>
                </Form>
                </Panel>
            );
    }
    homeworkTable = () => {
        
        return (
            <Panel header="已提交作业" bordered>
                <Table
                    height={300}
                    data={this.props.homeworkTable}
                >
                    <Column width={70} align="center" fixed >
                        <HeaderCell>作业标题</HeaderCell>
                        <Cell dataKey="title"/>
                    </Column>

                    <Column width={100} fixed>
                        <HeaderCell>提交日期</HeaderCell>
                        <Cell dataKey="uploadDate" />
                    </Column>
                    <Column width={200} fixed>
                        <HeaderCell>文件名</HeaderCell>
                        <Cell dataKey="fileName" />
                    </Column>
                    <Column width={100} fixed="right">
                        <HeaderCell>操作</HeaderCell>

                        <Cell>
                            {rowData => {
                                var self = this;
                                function handleAction() {

                                    alert("删除中" + rowData.fileName);
                                    //axios.delete("api/Homeworks/" + rowData.id);
                                    self.props.deleteHomework(self.props.homeworkTable.indexOf(rowData), rowData.id); 
                                }
                              
                                return (
                                    <ButtonGroup>
                                        <Button href={URL+"/api/Homeworks/download/"+rowData.id} size="xs" appearance="primary">下载</Button> 
                                        <Button onClick={handleAction} size="xs" > 删除 </Button>
                                    </ButtonGroup>
                                );
                            }}
                        </Cell>
                    </Column>
                </Table>
            </Panel>
        );
    }
    missionsTable = () => {
        return (
            <Panel header="任务列表" bordered collapsible>
                <Table
                    height={200}
                    data={this.props.missions}
                >
                    <Column width={90} align="center" fixed >
                        <HeaderCell>任务标题</HeaderCell>
                        <Cell dataKey="title" />
                    </Column>
                    <Column width={110} fixed>
                        <HeaderCell>发布日期</HeaderCell>
                        <Cell dataKey="uploadDate" />
                    </Column>
                    <Column width={120} align="center" fixed >
                        <HeaderCell>截止日期</HeaderCell>
                        <Cell dataKey="deadline" />
                    </Column>
                    <Column width={80} fixed>
                        <HeaderCell>发布人</HeaderCell>
                        <Cell dataKey="uploaderName" />
                    </Column>
                    <Column width={80} fixed="right">
                        <HeaderCell>操作</HeaderCell>

                        <Cell>
                            {rowData => {
                                var self = this;
                                function handleAction() {

                                    self.setState({
                                        show: true,
                                        mission: rowData
                                    });                                                                      
                                }
                                return (
                                    <span>
                                        <a onClick={handleAction}> 查看详细 </a>
                                       
                                    </span>
                                );
                            }}
                        </Cell>
                    </Column>
                </Table>
            </Panel>
        );
    }
    render() {
        const show = this.props.show;
        const id = this.props.userid;
        //const data = this.props.homeworkTable;
        return (
            <div>
                
                <Drawer
                    //full
                    show={show}
                    //size={'lg'}
                    onHide={this.props.onHide}
                >
                    <Drawer.Header>
                        <Drawer.Title>操作面板</Drawer.Title>
                    </Drawer.Header>
                    <Drawer.Body>
                        <p>工程管理面板</p>
                    </Drawer.Body>
                    <Drawer.Footer>
                        {this.props.children}
                    </Drawer.Footer>
                </Drawer>
            </div>
        );
    }
}

export default CtrlPanel;